<template>
  <v-container pa-0 ma-0 fluid>
    <v-row id="home-board" relaive :class="randomBgClass">
      <v-col cols="12" lg="6" md="10" xs="12">
        <v-layout class="home-board-content" column>
          <v-flex text-center>
            <h1 class="home-board-hdr">
              <span class="d-block l1">
                {{ content.header }}
              </span>
              <span class="mob-display d-block l2 mt-2 mb-4">
                {{ content.subHeader }}
              </span>
            </h1>
          </v-flex>

          <v-flex xs6 id="home-search" text-center>
            <SearchManager :isIndex="true" @closeList="pressed = false" />
          </v-flex>
          <!-- <v-flex> -->
            <v-row class="links-wrapper">
              <v-col   class="popular-links pl-0">
               <div> <p>{{ content.popularSearchJobs.title }}</p></div>
               <div class="links-wrapper-inner">
                 <nuxt-link class="volunteer" @click.native="popularSearchGtm(content.popularSearchJobs.soldier.name)" :title="content.popularSearchJobs.soldier.name" :to="content.popularSearchJobs.soldier.link">{{ content.popularSearchJobs.soldier.name }}</nuxt-link>
                 <nuxt-link class="volunteer" @click.native="popularSearchGtm(content.popularSearchJobs.parent.name)" :title="content.popularSearchJobs.parent.name" :to="content.popularSearchJobs.parent.link">{{ content.popularSearchJobs.parent.name }}</nuxt-link>
                 <nuxt-link  class="volunteer" @click.native="popularSearchGtm(content.popularSearchJobs.temp.name)" :title="content.popularSearchJobs.temp.name" :to="content.popularSearchJobs.temp.link">{{ content.popularSearchJobs.temp.name }}</nuxt-link>
                </div>
              </v-col>
              <v-col class="show-all-selection-wrapper">
                <p
                  class="pointer show-all-selection text-no-wrap"
                  @click="openList"
                  ref="showAll"
                >
                  {{ t('titles.selectAllCats') }} >
                </p>

                <DropAllSelection
                  v-show="pressed"
                  :text="'רשימת תחומים'"
                  :pressed.sync="pressed"
                />
              </v-col>
            </v-row>
          <!-- </v-flex> -->
        </v-layout>
      </v-col>
    </v-row>
  </v-container>
  <!-- Section board -->
</template>

<script>
import { mapGetters } from 'vuex';
import gtm from '@/lib/gtm';
import { t } from '@/store/modules/homeDrushim/constantsContent';
import SearchManager from '@/components/JobsSearch/SearchManager';
import DropAllSelection from '@/components/Dialogs/Categories/DropAllSelection.vue';

export default {
  components: {
    DropAllSelection,
    SearchManager
  },

  data() {
    return {
      pressed: false,
      isMobile: false,
      content: t('titles.topBoard'),
      bgClass: ['banner-pc-bg-2', 'banner-pc-bg-3', 'banner-pc-bg-4']
    };
  },

  computed: {
    randomBgClass() {
      return (
        !this.isMobile &&
        this.bgClass[Math.floor(Math.random() * this.bgClass.length)]
      );
    },
    ...mapGetters(['filteredList'])
  },

  mounted() {
    this.onResize();
  },

  methods: {
    popularSearchGtm(name) {
      gtm({
        category: 'filter_search',
        action: name,
        event: 'filter_search'
      });
    },
    onResize() {
      this.isMobile = window.innerWidth < 600;
    },
    openList() {
      this.pressed = !this.pressed;
    }
  }
};
</script>

<style lang="scss">
.show-all-selection-wrapper {
  max-width: 250px;
}
.show-all-selection {
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  color: $primary;
}
.links-wrapper {
  padding: 0 15px;
  justify-content: space-between;
  max-width: 800px;
  .links-wrapper-inner {
    text-align: center;
  }
}

.popular-links {
  display: flex;
  flex-wrap: nowrap;
  align-content: center;
  // justify-content: space-evenly;
  align-items: center;
  // width: 400px;

  p {
    display: inline;
    font-weight: 400;
  }
  a {
    color: black;
    // border: 1px solid gray;
    border-radius: 20px;
    padding: 5px;
    font-size: 14px;
    margin: 3px;
  }
  .regular {
    border: 1px solid gray;
    padding: 5px 7px;
  }
  .volunteer {
    border: 1px solid #000;
    padding: 5px 7px;
    font-weight: 400;
    // background-color: #f3f3f3;
  }
}

.popular-links a {
  white-space: nowrap;
}

@media screen and (max-width: 1700px) {
  .links-wrapper {
    max-width: 800px;
  }
}

@media screen and (max-width: 1510px) {
  .popular-links {
    justify-content: center;
    display: flex;
    flex-wrap: nowrap;
    align-content: center;
    align-items: baseline;
  }

  .links-wrapper {
    flex-direction: column-reverse;
    justify-content: center;
    margin: 0 auto;
  }
  .show-all-selection-wrapper {
    max-width: 100%;
  }
}
@media screen and (max-width: 600px) {
  .links-wrapper {
    flex-direction: column-reverse;
  }
  .show-all-selection {
    font-size: 16px;
    font-weight: 500;
    line-height: 23px;
    letter-spacing: 0px;
    text-align: center;
    margin-right: 0;
    flex-direction: column-reverse;
    color: $primary;
  }
  .show-all-selection-wrapper {
    color: $primary;
    transform: translate(0, 10px);
  }
  .popular-links {
    margin-right: 0;
    flex-direction: column;
    align-items: normal;
    a {
      color: #000;
      border-radius: 20px;
      padding: 2px;
      // font-size: 12px;
      padding: 5px;
      margin: 3px;
      background-color: #f3f3f3;
    }
    .regular {
      border: 1px solid gray;
    }
    .volunteer {
      border: 1px solid #000;
      // font-weight: 500;
    }
    p {
      display: block;
      font-weight: 400;
      padding-bottom: 15px;
      text-align: center;
    }
  }
}
</style>
